import { MessageMedium } from 'constants/messageMediums';
import styled from 'styled-components';
import { NoResult } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { colors, smallShadow, spacing } from 'ui/theme';

const StyledCard = styled.div`
  padding: ${spacing.double};
  background-color: ${colors.white};
  border: ${spacing.single} solid ${colors.grey5};
  border-radius: ${spacing.half};
  ${smallShadow}
`;

export const NO_RESULTS_TEXT = {
  TITLE: 'No results to display',
  SUBTITLE: 'Try using a different search term or switching message types from the left column.',
  ID: 'no-channel-results',
};

export type Props = {
  messageMedium: MessageMedium;
};

export const NoResultsCard = () => {
  return (
    <StyledCard data-testid={NO_RESULTS_TEXT.ID}>
      <EmptyState
        Illustration={NoResult}
        title={NO_RESULTS_TEXT.TITLE}
        subtitle={NO_RESULTS_TEXT.SUBTITLE}
      />
    </StyledCard>
  );
};
